<template>
  <div class="field">
    <label class="label">Phone Number</label>
    <div class="control">
      <input
        class="input"
        type="text"
        placeholder="..."
        :value="value"
        @input="updateValue"
        @focusout="handleChange"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PhoneNumber',
  props: {
    value: {
      required: true,
      validator: prop => typeof prop === 'string' || prop === null
    },
    userId: {
      type: Number,
      required: true
    }
  },
  methods: {
    updateValue (event) {
      this.$emit('input', event.target.value)
    },
    async handleChange () {
      try {
        await this.$caller.request('put', `/users/${this.userId}`, 'admin_headers', { phone_number: this.value })
        this.$utils.emit('show_toast', { text: 'Success' })
      } catch (e) {
        this.$utils.emit('show_toast', { text: 'failed' })
      }
    }
  }
}
</script>
